module.exports = __webpack_public_path__ + "img/minimize.aad0aeb1.png";